import { Count_Products_By } from '@occc/graphql';
import { PurchaseFormInitialValues } from '@occc-app/routes/Audience/components/Purchases/types';

import { TransactionTimePeriod } from '../../types';
import { SelectData } from '../../../../design-system/inputs/FinalForm';

export enum TransactionsMemberPurchasedOperator {
  MoreThan = 'MoreThan',
  MoreOrEqualTo = 'MoreOrEqualTo',
  LessThan = 'LessThan',
  LessThanOrEqualTo = 'LessThanOrEqualTo',
}

export const hasPurchased: SelectData[] = [
  {
    label: 'More than',
    value: TransactionsMemberPurchasedOperator.MoreThan,
  },
  {
    label: 'More than or equal to',
    value: TransactionsMemberPurchasedOperator.MoreOrEqualTo,
  },
  {
    label: 'Less than',
    value: TransactionsMemberPurchasedOperator.LessThan,
  },
  {
    label: 'Less than or equal to',
    value: TransactionsMemberPurchasedOperator.LessThanOrEqualTo,
  },
];

export const TransactionsMemberPurchasedOperatorToTitleMap: Record<
  TransactionsMemberPurchasedOperator,
  string
> = {
  [TransactionsMemberPurchasedOperator.MoreThan]: 'more than',
  [TransactionsMemberPurchasedOperator.MoreOrEqualTo]: 'more than or equal to',
  [TransactionsMemberPurchasedOperator.LessThan]: 'less than',
  [TransactionsMemberPurchasedOperator.LessThanOrEqualTo]: 'less than or equal to',
};

export const countProductsBy: SelectData[] = [
  { label: 'Product Quantity', value: Count_Products_By.Quantity },
  { label: 'Money Amount', value: Count_Products_By.MoneyAmount },
];

export const audiencePurchasesInitialFormValues: PurchaseFormInitialValues = {
  type: TransactionsMemberPurchasedOperator.MoreThan,
  countProductsBy: Count_Products_By.Quantity,
  timePeriodType: TransactionTimePeriod.PreviousMonth,
  locations: [],
  locationGroups: [],
  productGroups: [],
};

export const timePeriodOptions: SelectData[] = [
  { label: 'Previous Month', value: TransactionTimePeriod.PreviousMonth },
  { label: 'Rolling Window', value: TransactionTimePeriod.RollingWindow },
  { label: 'Fixed Month', value: TransactionTimePeriod.FixedMonth },
  { label: 'Fixed Window', value: TransactionTimePeriod.FixedWindow },
  { label: 'All Time', value: TransactionTimePeriod.AllTime },
];
